import React from "react";
import { IAutomationMail } from "../../interfaces/IAutomationMail";
import { IRole } from "../../interfaces/IRole";
import { Autocomplete, AutocompleteRenderInputParams, Box, Grid, MenuItem, TextField } from "@mui/material";
import { CustomeTextField } from "../core/CustomeTextField";
import { CustomEditor } from "../core/CustomEditor";

interface IProps {
    autoMail: IAutomationMail;
    setAutoMail: Function;
    roleArray: IRole[];
}

export const AutomationMailEdit: React.FC<IProps> = ({ autoMail, setAutoMail, roleArray }) => {
    const setText = (txt: string) => {
        setAutoMail({ ...autoMail!, body: txt });
    };

    return (
        <>
            <Grid container spacing={2}>
                <Grid item sm={4}>
                    <CustomeTextField
                        label="Editierbar durch MA"
                        attr="is_edit"
                        object={autoMail}
                        setObject={setAutoMail}
                        type="boolean"
                    />
                </Grid>
                <Grid item sm={4}>
                    <CustomeTextField
                        label="Senden nur bei MA interaktion"
                        attr="send_just_with_UserInteraction"
                        object={autoMail}
                        setObject={setAutoMail}
                        type="boolean"
                    />
                </Grid>
                <Grid item sm={4}>
                    <CustomeTextField
                        label="Von durch MA änderbar"
                        attr="is_edit_send_from"
                        object={autoMail}
                        setObject={setAutoMail}
                        type="boolean"
                    />
                </Grid>
                <Grid item sm={12}>
                    <CustomeTextField
                        attr="send_from"
                        label="Senden von"
                        object={autoMail}
                        setObject={setAutoMail}
                        type="select"
                    >
                        {[
                            {
                                id: 1,
                                label: "Aktueller Benutzer",
                            },
                            {
                                id: 2,
                                label: "Innendienst",
                            },
                            {
                                id: 3,
                                label: "Außendienst",
                            },
                            {
                                id: 4,
                                label: "Bauleitung",
                            },
                            {
                                id: 5,
                                label: "System",
                            },
                        ].map((entry) => (
                            <MenuItem key={`send-from-option-${entry.id}`} value={entry.id}>
                                {entry.label}
                            </MenuItem>
                        ))}
                    </CustomeTextField>
                </Grid>

                <Grid item sm={6}>
                    <TextField
                        label="Titel (nur intern)"
                        size="small"
                        value={autoMail.title}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                            setAutoMail({ ...autoMail, title: event.target.value })
                        }
                        error={autoMail.title === ""}
                        fullWidth
                    />
                </Grid>

                <Grid item sm={6}>
                    <TextField
                        label="Betreff"
                        size="small"
                        value={autoMail.subject}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                            setAutoMail({ ...autoMail, subject: event.target.value })
                        }
                        error={autoMail.subject === ""}
                        fullWidth
                    />
                </Grid>
                <Grid item sm={12}>
                    <Autocomplete
                        multiple
                        fullWidth
                        options={roleArray}
                        getOptionLabel={(option: IRole) => {
                            return option.role;
                        }}
                        value={roleArray.filter((role) => autoMail.send_to_roles.includes(role.id))}
                        onChange={(_, newValue) => {
                            setAutoMail({
                                ...autoMail,
                                send_to_roles: newValue.map((x) => x.id),
                            });
                        }}
                        renderInput={(params: AutocompleteRenderInputParams) =>
                            React.createElement(TextField, {
                                ...(params as any),
                                label: "Empfängerrollen",
                                variant: "standard",
                            })
                        }
                        size="small"
                    />
                </Grid>
            </Grid>

            <Box sx={{ mt: 5 }} />

            <Grid container spacing={2}>
                <CustomEditor txt={autoMail.body} setTxt={setText} dictonaryIdsArray={[]} dictionaryEntryArray={[]} />
            </Grid>
        </>
    );
};
